import { createSvgIcon } from '@mui/material';

export const HSBCIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='41'
    // viewBox='0 0 53 41'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19243_22613)'>
      <rect
        x='8'
        y='4.72412'
        width='37.25'
        height='24.5521'
        rx='4.29851'
        fill='white'
      />
      <rect
        x='7.91045'
        y='4.63457'
        width='37.4291'
        height='24.7312'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path d='M32.4 11.2251H20.8636V22.7615H32.4V11.2251Z' fill='white' />
      <path
        d='M38.1682 17.0069L32.4 11.2251V22.7751L38.1682 17.0069Z'
        fill='#DB0011'
      />
      <path
        d='M26.6318 17.0069L32.4 11.2251H20.8636L26.6318 17.0069Z'
        fill='#DB0011'
      />
      <path
        d='M15.0818 17.0069L20.8636 22.7751L20.8636 11.2251L15.0818 17.0069Z'
        fill='#DB0011'
      />
      <path
        d='M26.6318 17.0069L20.8636 22.7751H32.4L26.6318 17.0069Z'
        fill='#DB0011'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19243_22613'
        x='0.656622'
        y='0.962832'
        width='51.9368'
        height='39.2385'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19243_22613'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19243_22613'
          result='effect2_dropShadow_19243_22613'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19243_22613'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'HSBCIcon',
);
